import {
  ANALYTICS_FETCH,
  ANALYTICS_FETCH_FAILURE,
  ANALYTICS_FETCH_SUCCESS,
  ANALYTICS_RESET,
  ANALYTICS_SET,
  ANALTYCS_LOADING,
  ANALTYCS_LOADING_DONE,
  ANALYTICS_INIT_FETCH_SUCCESS,
  FINANCIAL_INSIGHTS_LOADING_DONE,
  FINANCIAL_INSIGHTS_LOADING,
  FINANCIAL_INSIGHTS_FETCH_FAILURE,
  FINANCIAL_INSIGHTS_FETCH_SUCCESS,
  FINANCIAL_INSIGHTS_FETCH,
} from "../actionTypes";

const INITIAL_STATE = {
  sales_kpis: {},
  sales: [],
  sales_companies: {},
  loading_sales_kpis: false,
  loading_sales: false,
  loading_sales_companies: false,
  loading: false,
  error: null,
};

export default function FinancialInsightsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FINANCIAL_INSIGHTS_FETCH: {
      const { payload } = action;
      return { ...state, [`loading_${payload.type}`]: true, error: null, sales: [] };
    }
    case FINANCIAL_INSIGHTS_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        [payload.type]: payload.data,
        [`loading_${payload.type}`]: false,
        error: null,
      };
    }
    case FINANCIAL_INSIGHTS_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    case FINANCIAL_INSIGHTS_LOADING:
      return { ...state, loading: true };
    case FINANCIAL_INSIGHTS_LOADING_DONE:
      return { ...state, loading: false };
    default:
      return state;
  }
}
